/** 本地开发：跳过微信环境检测、审核页预览 */
export const isLocalDevHost = () => {
  if (process.env.NODE_ENV !== 'development') return false
  const host = window.location.hostname
  return host === 'localhost' || host === '127.0.0.1' || host === '192.168.31.158'
}

export const isReviewPreviewPath = (path) =>
  /^\/review-success(\/preview)?$/.test(path) ||
  /^\/review-rejected\/preview$/.test(path) ||
  /^\/review-pending\/preview$/.test(path)
